import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiPhone, FiMail, FiMapPin, FiFacebook, FiTwitter, FiInstagram, FiLinkedin } = FiIcons;

const Footer = ({ className }) => {
  return (
    <footer className={`bg-gray-900 text-white ${className || ''}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <img src="/home image.jpeg" alt="How2Apply logo" className="h-10 w-10 object-cover rounded-md" />
              <h3 className="text-xl font-bold">How2Apply</h3>
            </div>
            <p className="text-gray-300 text-sm">
              Professional application filling services from the comfort of your home. Avoid queues, save time, and ensure accuracy with our expert operators.
            </p>
            <p className="text-gray-300 text-sm">
              Any other services, please connect with us via mail or mobile.
            </p>
            <div className="flex space-x-4">
              <SafeIcon icon={FiFacebook} className="w-5 h-5 text-gray-400 hover:text-white cursor-pointer transition-colors" />
              <SafeIcon icon={FiTwitter} className="w-5 h-5 text-gray-400 hover:text-white cursor-pointer transition-colors" />
              <SafeIcon icon={FiInstagram} className="w-5 h-5 text-gray-400 hover:text-white cursor-pointer transition-colors" />
              <SafeIcon icon={FiLinkedin} className="w-5 h-5 text-gray-400 hover:text-white cursor-pointer transition-colors" />
            </div>
          </div>

          {/* Student Services */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold">Student Services</h4>
            <ul className="space-y-2 text-sm text-gray-300">
              <li>College Applications</li>
              <li>Scholarship Applications</li>
              <li>Entrance Exam Forms</li>
              <li>Education Loans</li>
            </ul>
          </div>

          {/* Job Seeker Services */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold">Job Seeker Services</h4>
            <ul className="space-y-2 text-sm text-gray-300">
              <li>Job Applications</li>
              <li>Resume Building</li>
              <li>Government Job Forms</li>
              <li>Career Guidance</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold">Contact Us</h4>
            <div className="space-y-3 text-sm text-gray-300">
              <div className="flex items-center space-x-2">
                <SafeIcon icon={FiPhone} className="w-4 h-4" />
                <span>8367013267</span>
              </div>
              <div className="flex items-center space-x-2">
                <SafeIcon icon={FiMail} className="w-4 h-4" />
                <span>support@how2apply.net</span>
              </div>
              <div className="flex items-start space-x-2">
                <SafeIcon icon={FiMapPin} className="w-4 h-4 mt-0.5" />
                <span>KHAMMAM, TELANGANA, INDIA</span>
              </div>
              <div className="text-sm text-gray-400 mt-2">
                <p>Customer Support: 8:00 AM - 11:00 PM</p>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm text-gray-400">
          <p>&copy; 2024 How2Apply. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;